import { Tick, Text as Type } from '@/components/icons';
import CollapsibleSection from '@/components/ui/collapsible-section';
import { FONT_OPTIONS } from '../constants';
import { summarizeFont } from '../summarize';

interface FontSectionProps {
    open: boolean;
    onToggle: () => void;
    localFont: string;
    setLocalFont: (font: string) => void;
}

export function FontSection({ open, onToggle, localFont, setLocalFont }: FontSectionProps) {
    return (
        <CollapsibleSection
            title="Tipografia"
            testId="customize-section-font"
            icon={Type}
            summary={summarizeFont(localFont)}
            open={open}
            onToggle={onToggle}
            contentClassName="grid grid-cols-2 gap-2"
        >
            {FONT_OPTIONS.map((font) => (
                <button
                    key={font.value}
                    onClick={() => setLocalFont(font.value)}
                    className={`rounded-lg border-2 p-2 text-left transition-all ${
                        localFont === font.value
                            ? 'border-[#00006B] bg-[#00006B]/5'
                            : 'border-border hover:border-border-strong'
                    }`}
                >
                    <div className="flex items-center justify-between gap-1">
                        <span
                            className="truncate text-xs font-medium"
                            style={{ fontFamily: font.value }}
                        >
                            {font.name}
                        </span>
                        {localFont === font.value && (
                            <Tick className="size-3 flex-shrink-0 text-[#00006B]" />
                        )}
                    </div>
                </button>
            ))}
        </CollapsibleSection>
    );
}
